/** PURE_IMPORTS_START .._.._Observable,.._.._operator_bufferTime PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { bufferTime } from '../../operator/bufferTime';
Observable.prototype.bufferTime = bufferTime;
//# sourceMappingURL=bufferTime.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/operator/bufferTime.js
// module id = null
// module chunks = 